<template>
  <div class="member_space">
    <member-banner class="member_banner"></member-banner>
    <div class="member_body">
      <div class="common_menu">
        <el-row>
          <el-col :span="2">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="4" v-for="(item,index) in memberArr" :key="index">
            <div class="menu_item" :class="{ active_menu:activeIndex==index }" @click="memeberSelect(index)">{{item.name}}</div>
          </el-col>
          <el-col :span="2">
            <div>&nbsp;</div>
          </el-col>
        </el-row>
      </div>
      <div class="club-list">
        <div v-for="(itemM,index) in showArr" :key="index" class="member_info_room">
          <el-row :gutter="30">
            <el-col :span="24" class="club-pot">
              <div class="line">
                <el-col :span="4">
                  <div class="club-img-cup">
                    <img :src="itemM.orgImg" class="image" width="160" height="100">
                  </div>
                </el-col>
                <el-col :span="20">
                  <div>
                    <div class="club-text-title">{{itemM.orgName}}</div>
                    <div v-if="itemM.orgType===1" class="color1 club-text-item">{{itemM.orgTypeName }}</div>
                    <div v-if="itemM.orgType===2" class="color2 club-text-item">{{itemM.orgTypeName }}</div>
                    <div v-if="itemM.orgType===3" class="color3 club-text-item">{{itemM.orgTypeName }}</div>
                    <div v-if="itemM.orgType===4" class="color4 club-text-item">{{itemM.orgTypeName }}</div>
                    <div class="club-ptext" v-html="itemM.orgText"></div>
                  </div>
                </el-col>
              </div>
            </el-col>
          </el-row>
          <div class="hr-type">
            <hr class="hr-style" />
          </div>
        </div>
        <div class="news_page">
          <el-pagination :page-size="pageSize" layout="prev, pager, next" :total="totalPage" @current-change="turnPage" background class="pager_style">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import memberBanner from './memberBanner';
import { viewMembers } from '@/api/frontApi/frontMembers';
export default {
  data() {
    return {
      memberArr: [
        {
          name: '所有会员单位'
        },
        {
          name: '理事长单位'
        },
        {
          name: '副理事长单位'
        },
        {
          name: '常务理事单位'
        },
        {
          name: '理事单位'
        }
      ],
      activeIndex: 0,
      memberList: [],
      whichMembers: [], // 具体查看哪种类型的单位
      showArr: [],
      pageNo: 1,
      pageSize: 5,
      totalPage: 1
    };
  },
  components: {
    memberBanner
  },
  computed: {
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  created() {
    this.initMemberList();
  },
  methods: {
    initMemberList(memberType) {
      let params = {
        pageNo: this.pageNo,
        pageSize: 999,
        orgType: memberType
      };
      viewMembers(params).then(res => {
        let tempLen = res.data.records.length;
        for (let q = 0; q < tempLen; q++) {
          if (res.data.records[q].orgImg) {
            continue;
          } else {
            res.data.records[q].orgImg = this.defaultImg;
          }
        }
        this.totalPage = res.data.total;
        this.memberList = res.data.records;
        this.showArr = this.memberList.slice(0, this.pageSize);
      });
    },
    openMembers(orgId) {
      this.$router.push({ name: 'memeberInfo', params: { mid: orgId } });
    },
    memeberSelect(key) {
      this.whichMembers = [];
      this.totalPage = 0;
      this.activeIndex = key;
      switch (parseInt(key)) {
        case 0:
          this.whichMembers = this.memberList;
          this.totalPage = this.whichMembers.length;
          break;
        case 1:
          this.memberList.forEach(item => {
            if (item.orgType === 1) this.whichMembers.push(item);
          });
          this.totalPage = this.whichMembers.length;
          break;
        case 2:
          this.memberList.forEach(item => {
            if (item.orgType === 2) this.whichMembers.push(item);
          });
          this.totalPage = this.whichMembers.length;
          break;
        case 3:
          this.memberList.forEach(item => {
            if (item.orgType === 3) this.whichMembers.push(item);
          });
          this.totalPage = this.whichMembers.length;
          break;
        case 4:
          this.memberList.forEach(item => {
            if (item.orgType === 4) this.whichMembers.push(item);
          });
          this.totalPage = this.whichMembers.length;
          break;
      }
      this.showArr = this.whichMembers.slice(0, this.pageSize);
    },
    turnPage(val) {
      this.pageNo = val;
      this.showArr = [];
      let b = (this.pageNo - 1) * this.pageSize;
      let e = b + this.pageSize;
      if (this.whichMembers.length) {
        this.showArr = this.whichMembers.slice(b, e);
      } else {
        this.showArr = this.memberList.slice(b, e);
      }
    }
  }
};
</script>
<style scoped>
.member_space {
  width: 100%;
  height: 100%;
  min-height:1020px;
  margin: 0px auto;
  position: relative;
  z-index: 50;
}
.member_banner {
  width: 100%;
}
.member_body {
  height: 100%;
  width:100%
}
.common_menu {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background-color: #e6e6e6;
  text-align: center;
}
.menu_item {
  width: 100%;
  height: 100%;
  font-size: 19px;
  color: #717171;
}
.menu_item:hover {
  cursor: pointer;
}
.active_menu {
  color: #fff;
  background-color: #093977;
}
.club-list {
  width: 60%;
  margin: 20px auto;
  min-width: 969px;
}
.club-pot {
  margin-top: 10px;
}
.cardStyle {
  text-align: center;
}
.club-text-title {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: bold;
  /* cursor: pointer; */
}
.club-text-item {
  margin-bottom: 5px;
}
.club-ptext {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  max-height: 80px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*超出部分省略号*/
  width: 100%;
}

.color1 {
  color: #f56c6c;
}
.color2 {
  color: #409eff;
}
.color3 {
  color: #67c23a;
}
.color4 {
  color: #e6a23c;
}
.hr-type {
  width: 98%;
  padding-left: 1%;
  margin-top: 10px;
}
.hr-style {
  background-color: #dcdcdc;
  height: 1px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/members/members.vue